(() => {
  function init(section) {
    if (!section || section.dataset.mvInitialized === "true") return;
    section.dataset.mvInitialized = "true";

    const cards = [...section.querySelectorAll(".mv-home__payload-card")];
    const track = section.querySelector(".mv-home__carousel-track");
    const carouselPrev = section.querySelector(".mv-home__carousel-prev");
    const carouselNext = section.querySelector(".mv-home__carousel-next");
    const dots = [...section.querySelectorAll(".mv-home__carousel-dot")];
    const heroPrev = section.querySelector(".mv-home__hero-prev");
    const heroNext = section.querySelector(".mv-home__hero-next");

    const activePayload = section.querySelector(".mv-home__active-payload");
    const detailsImage = section.querySelector(".mv-home__details-image");
    const title = section.querySelector(".mv-home__details-title");
    const description = section.querySelector(".mv-home__details-description");
    const specs = section.querySelector(".mv-home__details-specs");
    const infoPanel = section.querySelector("[data-payload-info-panel]");
    const infoHide = section.querySelector("[data-payload-info-hide]");
    const infoShow = section.querySelector("[data-payload-info-show]");

    if (!cards.length || !activePayload) return;

    function setInfoPanelHidden(hidden) {
      section.classList.toggle("mv-home--panel-hidden", hidden);
      if (infoPanel) infoPanel.setAttribute("aria-hidden", hidden ? "true" : "false");
      if (infoShow) infoShow.hidden = !hidden;
    }
    infoHide?.addEventListener("click", event => { event.preventDefault(); setInfoPanelHidden(true); });
    infoShow?.addEventListener("click", event => { event.preventDefault(); setInfoPanelHidden(false); });
    setInfoPanelHidden(section.classList.contains("mv-home--panel-hidden"));

    let currentIndex = Math.max(0, cards.findIndex(card => card.classList.contains("is-active")));

    function centerCard(index, behavior = "smooth") {
      if (!track || !cards[index]) return;
      const card = cards[index];
      const targetLeft = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
      track.scrollTo({ left: Math.max(0, targetLeft), behavior });
    }

    function setPayload(index, centerExplorer = false) {
      currentIndex = (index + cards.length) % cards.length;
      const card = cards[currentIndex];

      cards.forEach((item, itemIndex) => {
        item.classList.toggle("is-active", itemIndex === currentIndex);
        item.setAttribute("aria-current", itemIndex === currentIndex ? "true" : "false");
      });

      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === currentIndex;
        dot.classList.toggle("is-active", active);
        dot.setAttribute("aria-selected", active ? "true" : "false");
        dot.setAttribute("tabindex", active ? "0" : "-1");
      });

      const image = card.dataset.image || "";
      const payloadTitle = card.dataset.title || "";
      const payloadDescription = card.dataset.description || "";
      const specificationValues = [
        card.dataset.specOne,
        card.dataset.specTwo,
        card.dataset.specThree,
        card.dataset.specFour
      ].filter(Boolean);

      activePayload.classList.remove("is-changing");
      void activePayload.offsetWidth;
      activePayload.src = image;
      activePayload.alt = payloadTitle;
      activePayload.classList.add("is-changing");

      if (detailsImage) {
        detailsImage.src = image;
        detailsImage.alt = payloadTitle;
      }
      if (title) title.textContent = payloadTitle;
      if (description) description.textContent = payloadDescription;

      if (specs) {
        specs.replaceChildren();
        specificationValues.forEach(value => {
          const item = document.createElement("li");
          item.textContent = value;
          specs.appendChild(item);
        });
      }

      if (centerExplorer) centerCard(currentIndex);
    }

    function step(direction, centerExplorer = false) {
      setPayload(currentIndex + direction, centerExplorer);
    }

    cards.forEach((card, index) => {
      card.addEventListener("click", event => {
        event.preventDefault();
        setPayload(index, true);
      });
    });

    heroPrev?.addEventListener("click", event => {
      event.preventDefault();
      event.stopPropagation();
      step(-1, false);
    });

    heroNext?.addEventListener("click", event => {
      event.preventDefault();
      event.stopPropagation();
      step(1, false);
    });

    carouselPrev?.addEventListener("click", event => {
      event.preventDefault();
      event.stopPropagation();
      step(-1, true);
    });

    carouselNext?.addEventListener("click", event => {
      event.preventDefault();
      event.stopPropagation();
      step(1, true);
    });

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener("click", event => {
        event.preventDefault();
        setPayload(dotIndex, true);
      });
    });

    setPayload(currentIndex, false);
  }

  function initAll(root = document) {
    root.querySelectorAll(".mv-home").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", event => initAll(event.target));
  document.addEventListener("shopify:section:reorder", () => initAll());
})();


(() => {
  const updateClock = () => {
    const now = new Date();
    document.querySelectorAll('[data-current-time]').forEach((el) => {
      el.textContent = now.toLocaleTimeString('en-US', { hour12: false });
    });
    document.querySelectorAll('[data-current-date]').forEach((el) => {
      el.textContent = now.toLocaleDateString('en-CA');
    });
  };
  updateClock();
  window.setInterval(updateClock, 1000);
})();
